<template>
<div class="wrap">
    <div class="noAuth">
  <el-table
    :data="tableData"
    stripe
    style="width: 40%">
    <el-table-column
      prop="name"
      label="姓名"
      width="180">
    </el-table-column>
    <el-table-column
      prop="idCard"
      label="身份证号"
      width="180">
    </el-table-column>
    <el-table-column
      prop="authState"
      label="认证状态">
    </el-table-column>
  </el-table>
  </div>
  <div class="yesAuth">
  <el-table
    :data="tableData"
    stripe
    style="width: 40%">
    <el-table-column
      prop="name"
      label="姓名"
      width="180">
    </el-table-column>
    <el-table-column
      prop="idCard"
      label="身份证号"
      width="180">
    </el-table-column>
    <el-table-column
      prop="authState"
      label="认证状态">
    </el-table-column>
  </el-table>
  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: [{
          idCard: '',
          name: '',
          authState: ''
        },{
            
        }]
      }
    },
    methods:{
        
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Myvue/wxPush.vue